// src/data/newsrestoftheworld.js
// News data for the Special Articles section

const newsSpecialArticles = [
  {
    aid: 1,
    title: 'Casual, Conversational Interview With a Cardiac Surgeon - Dr. Mehta',
    aboutdescription: 'A detailed interview discussing common heart problems and prevention tips.',
    imagepath: '/images/articlesimages/yourdoctor_cardio_s1.png',
    urlshare: '/components/interview_doctor_cardio_a1.jsx',
    featuredlisting: true,
    listingorder: 1,
    liststatus: 'Active',
    postedtime: 'Nov 25, 2025, 10:00 AM',
  },
  {
    aid: 2,
    title: 'Orthopedic innovation Conversational Interview With an Orthopedic Surgeon - Dr. Patel',
    aboutdescription: 'A detailed interview discussing orthopedic innovations and treatments.',
    imagepath: '/defaultlogos/orthopedic_doctor_logo.svg',
    urlshare: 'interview_doctor_ortho_a1.jsx',
    featuredlisting: true,
    listingorder: 1,
    liststatus: 'Active',
    postedtime: 'Nov 25, 2025, 10:00 AM',
  },
  {
    aid: 3,
    title: 'Conversational Interview With an Orthopedic Surgeon - Dr. Singh',
    aboutdescription: 'A detailed interview discussing common orthopedic issues and treatment options.',
    imagepath: '/defaultlogos/orthopedic_doctor_logo.svg',
    urlshare: 'interview_doctor_ortho_a2.jsx',
    featuredlisting: true,
    listingorder: 2,
    liststatus: 'Active',
    postedtime: 'Nov 25, 2025, 10:00 AM',
  },
  {
    aid: 4,
    title: 'Gynecological health Interview With a Gynecologist - Dr. Sneha Shinde',
    aboutdescription: 'A detailed interview discussing common gynecological issues and health tips.',
    imagepath: '/defaultlogos/obg_gyno_logo.svg',
    urlshare: 'interview_doctor_gynec_a1.jsx',
    featuredlisting: true,
    listingorder: 2,
    liststatus: 'Active',
    postedtime: 'Nov 25, 2025, 10:00 AM',
  },
  // --- Current Affairs Articles ---
  {
    aid: 101,
    title: 'Business & Stock Market Trends',
    aboutdescription: 'Domestic and global market outlook. Click to read the full article.',
    imagepath: '/images/articlesimages/current_affairs_business.jpg',
    urlshare: 'curaffairs_BusinessStockMarketTrends.jsx',
    featuredlisting: false,
    listingorder: 1,
    liststatus: 'Active',
    postedtime: 'Jan 10, 2026, 09:00 AM',
    specialcategory: 'Current Affairs',
  },
  {
    aid: 102,
    title: 'Global Unrest and Its Impact',
    aboutdescription: 'Geopolitical tensions shaping the present world. Click to read the full article.',
    imagepath: '/images/articlesimages/current_affairs_unrest.jpg',
    urlshare: 'curaffairs_GlobalUnrestImpact.jsx',
    featuredlisting: false,
    listingorder: 2,
    liststatus: 'Active',
    postedtime: 'Jan 11, 2026, 11:00 AM',
    specialcategory: 'Current Affairs',
  },
  {
    aid: 103,
    title: 'Artificial Intelligence: Science & Technology',
    aboutdescription: 'Transforming the world in the 21st century. Click to read the full article.',
    imagepath: '/images/articlesimages/curaffairs_artificialintelligence.png',
    urlshare: 'curaffairs_sciencetechnology_ai.jsx',
    featuredlisting: false,
    listingorder: 3,
    liststatus: 'Active',
    postedtime: 'Jan 12, 2026, 10:00 AM',
    specialcategory: 'Current Affairs',
  },
  {
    aid: 104,
    title: 'Bearish Outlook for the Bullion Market (2026 and Beyond)',
    aboutdescription: 'After a strong multi-year rally, the bullion market shows early signs of fatigue. Gold and silver face technical exhaustion and macroeconomic headwinds. Click to read the full article.',
    imagepath: '/images/articlesimages/curaffairs_bullionmarkettrends.png',
    urlshare: 'curaffairs_commoditybulliontrends.jsx',
    featuredlisting: false,
    listingorder: 4,
    liststatus: 'Active',
    postedtime: 'Feb 7, 2026, 09:00 AM',
    specialcategory: 'Current Affairs',
  },
  {
    aid: 105,
    title: 'AI Doomsday? Raghuram Rajan on India Services Sector',
    aboutdescription: 'AI will disrupt India’s services sector, but adaptation and reskilling can keep growth on track. Click to read the full article.',
    imagepath: '/images/articlesimages/curaffairs_aidoomsday_raghuramrajan.png',
    urlshare: 'curaffairs_aiimpact_raghurajan.jsx',
    featuredlisting: false,
    listingorder: 5,
    liststatus: 'Active',
    postedtime: 'Feb 28, 2026, 09:00 AM',
    specialcategory: 'Current Affairs',
  },
  {
    aid: 106,
    title: 'Middle East Conflict Sends Shockwaves Across Asian Markets',
    aboutdescription: 'Rising geopolitical tensions are driving oil spikes, market volatility, and supply-chain risks across Asian economies. Click to read the full article.',
    imagepath: '/images/articlesimages/curaffairs_middleeastwar_impact_asianmarkets.jpg',
    urlshare: 'curaffairs_middleeastconflict_asianmarkets.jsx',
    featuredlisting: false,
    listingorder: 6,
    liststatus: 'Active',
    postedtime: 'Mar 22, 2026, 10:00 AM',
    specialcategory: 'Current Affairs',
  },
{
    aid: 107,
    title: 'Automation vs Employment: How Robotics is Reshaping Jobs in India and Other Developing Nations',
    aboutdescription: 'Automation is transforming the job landscape across Asian economies. Click to read the full article.',
    imagepath: '/images/articlesimages/curaffairs_robotics_impact_in_automobileindustry.jpg',
    urlshare: 'curaffairs_robotics_impact_in_automobileindustry.jsx',
    featuredlisting: false,
    listingorder: 6,
    liststatus: 'Active',
    postedtime: 'June 24, 2026, 03:00 PM',
    specialcategory: 'Current Affairs',
  },

  // --- Life Style Articles ---
  {
    aid: 201,
    title: '5 Simple Yoga Poses for Beginners',
    aboutdescription: 'Start your day with these easy yoga poses to boost flexibility and reduce stress. Perfect for all ages!',
    imagepath: '/images/articlesimages/lifestyle_yoga_s1.png',
    urlshare: '',
    featuredlisting: false,
    listingorder: 1,
    liststatus: 'Active',
    postedtime: 'Jan 12, 2026, 08:00 AM',
    specialcategory: 'Life Style',
  },
  {
    aid: 202,
    title: 'Healthy Eating: Local Superfoods',
    aboutdescription: 'Discover the health benefits of local superfoods like jackfruit, drumstick leaves, and finger millet. Tips and recipes inside!',
    imagepath: '/images/articlesimages/lifestyle_superfoods.jpg',
    urlshare: '',
    featuredlisting: false,
    listingorder: 2,
    liststatus: 'Active',
    postedtime: 'Jan 12, 2026, 10:00 AM',
    specialcategory: 'Life Style',
  },

];

export default newsSpecialArticles;

